import { useLocation } from "react-router-dom";

/**
 * Returns "renter" or "owner" based on current route.
 *
 * Renter surfaces (tenants land here directly from shared listing links,
 * search, and social):
 *   • /rentals + /rentals/*    — full browse catalogue
 *   • /residences + /residences/* — editorial listings & detail
 *
 * Owner surfaces (prospective property owners exploring management):
 *   • /              — homepage (owner-first hierarchy)
 *   • /owners        — pitch + free rent analysis
 *   • /about         — company story
 *
 * Shared surfaces default to "renter" (a rental company's front door
 * should assume the visitor wants to rent unless we know otherwise).
 */
export const useAudienceMode = () => {
  const { pathname } = useLocation();
  const p = pathname.replace(/\/$/, "");
  if (p === "" || p === "/") return "owner";
  if (p.startsWith("/owners")) return "owner";
  if (p.startsWith("/about")) return "owner";
  return "renter";
};
